import React, { Component } from 'react';

class Nav extends Component {
  render() {
    return(
      <div>
        <nav className="navbar navbar-dark">
          <div className="container">
            <a className="navbar-brand" href="#">
              <img src="assets/logo.png" alt="Logo" />
            </a>
            <nav role="navigation">
              <div id="menuToggle">
                <input type="checkbox" />
                <span />
                <span />
                <span />
                <ul id="menu">
                  <li><a href="#">Home</a></li>
                  <li><a href="#">Tentang</a></li>
                  <li><a href="#">Donasi</a></li>
                  <li><a href="#">Konfirmasi</a></li>
                  <li><a href="#">Info</a></li>
                </ul>
              </div>
            </nav>
          </div>
        </nav>
      </div>
    )
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js